import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-15/task-01";

const task: Slide = {
  titleHtml:
    "The bandwidth sensitivity of a pressure moving coil microphone loaded with infinite<br>resistance is controlled by its (multiple answers allowed).",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
